import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface GeneralTabProps {
    roleName: string;
    roleDescription: string;
    onRoleNameChange: (value: string) => void;
    onRoleDescriptionChange: (value: string) => void;
    readOnly?: boolean;
}

const GeneralTab = ({
    roleName,
    roleDescription,
    onRoleNameChange,
    onRoleDescriptionChange,
    readOnly = false,
}: GeneralTabProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles["general-tab"]}>
            <div className={styles["field-group"]}>
                <label htmlFor="role-name" className={styles["field-label"]}>
                    {t("Roles.Modal.RoleName")} *
                </label>
                <StyledTextField
                    id="role-name"
                    placeholder={t("Roles.Modal.RoleNamePlaceholder")}
                    value={roleName}
                    onChange={(e) => onRoleNameChange(e.target.value)}
                    fullWidth
                    disabled={readOnly}
                />
            </div>

            <div className={`${styles["field-group"]} ${styles["description-group"]}`}>
                <label htmlFor="role-description" className={styles["field-label"]}>
                    {t("Roles.Modal.Description")}
                </label>
                <StyledTextField
                    id="role-description"
                    placeholder={t("Roles.Modal.DescriptionPlaceholder")}
                    value={roleDescription}
                    onChange={(e) => onRoleDescriptionChange(e.target.value)}
                    multiline
                    fullWidth
                    disabled={readOnly}
                    sx={{ flex: 1, "& .MuiInputBase-root": { height: "100%", alignItems: "flex-start" } }}
                />
            </div>
        </div>
    );
};

export default GeneralTab;
